import React, { useEffect, useState } from 'react'
import TimeAgo from 'javascript-time-ago'
import en from 'javascript-time-ago/locale/en'

TimeAgo.addLocale(en)
const timeAgo = new TimeAgo('en-US')
const getTimeAgo = (date: string) => timeAgo.format(new Date(date))

interface Props {
  date: string
  updateRate?: number
}

export default function ReactTimeAgo({
  date,
  updateRate = 60,
  ...props
}: Props) {
  const [relative, setRelative] = useState(getTimeAgo(date))
  useEffect(() => {
    setRelative(getTimeAgo(date))
    const interval = setInterval(() => {
      setRelative(getTimeAgo(date))
    }, 60000)

    return () => clearInterval(interval)
  }, [date, updateRate])
  return <span {...props}>{relative}</span>
}
